import React from 'react';
import PropTypes from 'prop-types';
import SummaryTable from './SummaryTable';
import logTableQuery from './logTableQuery.graphql';
import style from './style.css';

const LogTable = props => {
    const totalSessions = 5;

    const { title, description, show, query } = props.settings;

    return (
        <>
            {show && (
                <div className={style.wrapper}>
                    <div>
                        <span style={{ fontWeight: 'bold', fontSize: '1.5em' }}>{title}</span>
                    </div>
                    <div style={{ marginBottom: '0.5em' }}>{description}</div>
                    <SummaryTable
                        totalSessions={totalSessions}
                        query={props.isPreview ? logTableQuery : query}
                        isPreview={props.isPreview}
                    />
                </div>
            )}
        </>
    );
};

LogTable.propTypes = {
    settings: PropTypes.object,
    isPreview: PropTypes.bool,
    filters: PropTypes.object,
};

LogTable.defaultProps = {
    filters: {},
};

export default LogTable;
